import { useContext } from 'react'
import { NavContext } from '../context/global_context'

export const HasPermission = (permission_type) => {
  const [state, dispatch] = useContext(NavContext)

  if (state?.permissions?.includes(permission_type)) {
    return true
  }
  return false
}
